module.exports = __webpack_public_path__ + "img/finance-bg.84c72dc7.png";